export const GENDER_STATUS = Object.freeze({
  MALE: 1,
  FEMALE: 2
})
